import React from 'react'
import { useMutation } from 'react-query'

import {
  BooleanField,
  FieldSpec,
  LinkedField,
  NumberField,
  PaginatedTable,
  RelatedLinkedField,
  SkuThresholdTargetField,
  ValueField,
} from 'src/components/Table'
import { skuit } from 'src/services/skuit'
import { SkuThreshold } from 'src/api/models'
import { ListTableProps } from './types'

const fieldOptions: { [key:string]: FieldSpec } = {
  guid: { id: 'guid', label: 'SquID', renderer: LinkedField(ValueField) },
  sku: { id: 'sku', label: 'SKU', ordering: 'sku__sku', renderer: RelatedLinkedField(ValueField, 'sku') },
  target: { id: 'target', label: 'Threshold Target', renderer: SkuThresholdTargetField },
  facility: { id: 'facility', label: 'Facility', ordering: 'facility__name', renderer: RelatedLinkedField(ValueField, 'name') },
  minCount: { id: 'minCount', label: 'Minimum Threshold', ordering: 'min_count', renderer: NumberField },
  refillCount: { id: 'refillCount', label: 'Refill Level', ordering: 'refill_count', renderer: NumberField },
  status: { id: 'status', label: 'Alert Status', ordering: 'triggered', renderer: BooleanField },
}

export const SkuThresholdListTable = (props: ListTableProps) => {
  const { paginator, fields, extraActions } = props

  const { mutate: deleteThreshold } = useMutation(
    skuit.sc.skus.thresholds.delete,
    { onSuccess: () => paginator.refresh() }
  )

  return (
    <PaginatedTable
      title="SKU Threshold Alerts"
      fields={fields.map((field) => fieldOptions[field])}
      paginator={paginator}
      actions={extraActions}
      rowActions={[{
        title: () => 'Delete',
        onClick: (row: SkuThreshold) => deleteThreshold(row.guid)
      }]}
    />
  )
}
